// extracted by mini-css-extract-plugin
module.exports = {"main":"PageLoader_main__2Ybp1","spinner":"PageLoader_spinner__3zVoa"};